// eslint-disable-next-line no-unused-vars
import React from 'react';
import { node, number, string, arrayOf, oneOfType } from 'prop-types';

import usePermissions from 'Hooks/usePermissions';

const Can = ({ permission, roles, fallback = null, children }) => {
  const { can, hasRole } = usePermissions();

  let allowed = false;
  if (permission) {
    allowed = can(permission);
  } else if (roles != null) {
    allowed = hasRole(...(Array.isArray(roles) ? roles : [roles]));
  }

  return allowed ? children : fallback;
};

Can.propTypes = {
  permission: string,
  roles: oneOfType([number, arrayOf(number)]),
  fallback: node,
  children: node,
};

Can.displayName = 'Can';

export { Can };
